import { render, staticRenderFns } from "./PropertyRights.vue?vue&type=template&id=6ef7d42a&scoped=true&"
import script from "./PropertyRights.vue?vue&type=script&lang=js&"
export * from "./PropertyRights.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRights.vue?vue&type=style&index=0&id=6ef7d42a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef7d42a",
  null
  
)

export default component.exports